'use client'

import { useState } from 'react'
import { MEASURECAMP_CALENDAR_URL } from '@/lib/measurecamp'
import { CopySimple } from '@phosphor-icons/react'

const webcalUrl = MEASURECAMP_CALENDAR_URL.replace(/^https:/, 'webcal:')

export default function CalendarSubscribe() {
  const [copyState, setCopyState] = useState<'idle' | 'copied' | 'error'>('idle')

  async function copyCalendarUrl() {
    try {
      await navigator.clipboard.writeText(MEASURECAMP_CALENDAR_URL)
      setCopyState('copied')
      window.setTimeout(() => setCopyState('idle'), 2500)
    } catch {
      setCopyState('error')
    }
  }

  return (
    <div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <a
          href={webcalUrl}
          className="inline-flex min-h-12 items-center justify-center whitespace-nowrap rounded-[8px] bg-[var(--portfolio-mint)] px-6 py-3 text-center text-sm font-semibold text-[#102b32] transition hover:-translate-y-px hover:bg-[#19f0ad]"
        >
          Subscribe
        </a>
        <button
          type="button"
          onClick={copyCalendarUrl}
          className="inline-flex min-h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[8px] border border-[var(--portfolio-line)] bg-[var(--portfolio-surface)] px-6 py-3 text-sm font-semibold text-[var(--portfolio-ink)] transition hover:border-[var(--portfolio-accent-text)]"
        >
          <CopySimple size={19} aria-hidden="true" /> {copyState === 'copied' ? 'URL copied' : copyState === 'error' ? 'Copy failed' : 'Copy URL'}
        </button>
      </div>
      <p className="mt-4 min-h-5 text-xs leading-5 text-[var(--portfolio-muted)]" aria-live="polite">
        {copyState === 'copied' ? 'Paste it into Google Calendar, Outlook, Apple Calendar, or any app that supports calendar subscriptions.' : 'A subscription stays updated automatically. Importing a downloaded file does not.'}
      </p>
    </div>
  )
}
